import { Provider } from "react-redux";
import Store from "@/redux/store";
import Context from "@/context/Context";

import PageHead from "@/pages/Head";
import HeaderStyleTen from "@/components/Header/HeaderStyle-Ten";
import MobileMenu from "@/components/Header/MobileMenu";
import Cart from "@/components/Header/Offcanvas/Cart";
import EventHead from "@/components/Events/EventHead";
import Separator from "@/components/Common/Separator";
import FooterOne from "@/components/Footer/Footer-One";
import EventList from "@/components/Events/Events";
import BackToTop from "@/pages/backToTop";
import { useState } from "react";
import { GET_ALL_EVENTS } from '@/graphql/querries/events'
import { useQuery } from "@apollo/client";

import EventData from "../../data/events.json";
import styles from "./events.module.scss"
import MarketFilter from "@/components/Category/Filter/MarketFilter";
import Pagination from "@/components/Common/Pagination";
import Spinner from "@/components/Spinner";
import { useEffect } from "react";

const EventListPage = () => {
  const [page, setPage] = useState(1);
  const [events, setEvents] = useState([])
  const [totalPages, setTotalPages] = useState(0);

  const { data: AllEvents, loading } = useQuery(GET_ALL_EVENTS, {
    variables: {
      paginationArgs: {
        pageSize: 25,
        pageNumber: page,
      },
    },
  });

  console.log("All events are", AllEvents?.getAllEvents)

  return (
    <>
      <PageHead title="Event List - See all available events today" />

      <Provider store={Store}>
        <Context>
          <HeaderStyleTen headerSticky="rbt-sticky" headerType="" />
          <MobileMenu />
          <Cart />

          <EventHead count={ AllEvents?.getAllEvents?.length } />
          <div className="rbt-counterup-area rbt-section-overlayping-top rbt-section-gapBottom">
            <div className="container">
              <EventList
                isPagination={true}
                parentClass="card-list-2 event-list-card"
                childClass="col-lg-6 col-md-6 col-12"
                getEvents={AllEvents?.getAllEvents}
              />
            </div>
          </div>


          {/* <div className="rbt-section-overlayping-top rbt-section-gapBottom">
        <div className="inner">
          <div className="container">
            {loading ? (
              <Spinner />
            ) : (
              <MarketFilter StoreItem={AllEvents?.getAllEvents} />
            )}

            <div className="row">
              <div className="col-lg-12 mt--60">
                <Pagination pageNumber={page} setPage={setPage} />
              </div>
            </div>
          </div>
        </div>
      </div> */}

          <BackToTop />
          <Separator />
          <FooterOne />
        </Context>
      </Provider>
    </>
  );
};

export default EventListPage;
